/* Naya Attire theme scripts */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = (format || 'Rs {{amount}}').replace(/<[^>]*>/g, '');
    function withDelimiters(num, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = format.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'"); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var theme = window.theme || {};

    // Mobile menu
    var menuBtn = document.querySelector('[data-menu-toggle]');
    var menu = document.getElementById('MobileMenu');
    if (menuBtn && menu) {
      menuBtn.addEventListener('click', function () {
        var open = menu.classList.toggle('is-open');
        menuBtn.setAttribute('aria-expanded', open);
      });
    }

    // Search toggle
    var searchBtn = document.querySelector('[data-search-toggle]');
    var search = document.getElementById('HeaderSearch');
    if (searchBtn && search) {
      searchBtn.addEventListener('click', function () {
        var open = search.classList.toggle('is-open');
        searchBtn.setAttribute('aria-expanded', open);
        if (open) { var i = search.querySelector('input[type=search]'); if (i) i.focus(); }
      });
    }

    // Quantity buttons (product + cart)
    document.querySelectorAll('.qty').forEach(function (box) {
      var input = box.querySelector('input');
      box.querySelectorAll('[data-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var min = parseInt(input.min || '0', 10);
          var v = (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qty, 10);
          input.value = Math.max(min, v);
        });
      });
    });

    // Collection sorting
    var sort = document.querySelector('[data-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    // Product page: variants + gallery
    document.querySelectorAll('[data-product-root]').forEach(function (root) {
      var jsonEl = root.parentNode.querySelector('[data-product-json]');
      if (!jsonEl) return;
      var product = JSON.parse(jsonEl.textContent);
      var idInput = root.querySelector('[data-variant-id]');
      var addBtn = root.querySelector('[data-add-btn]');
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare]');
      var mainImg = root.querySelector('[data-main-media] img');
      var thumbs = root.querySelectorAll('[data-thumb]');

      function showMedia(src, mediaId) {
        if (!mainImg || !src) return;
        mainImg.removeAttribute('srcset');
        mainImg.src = src;
        thumbs.forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.mediaId) === String(mediaId)); });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { showMedia(t.dataset.src, t.dataset.mediaId); });
      });

      var radios = root.querySelectorAll('input[data-option-index]');
      function currentOptions() {
        var opts = [];
        radios.forEach(function (r) { if (r.checked) opts[parseInt(r.dataset.optionIndex, 10)] = r.value; });
        return opts;
      }
      function update() {
        var opts = currentOptions();
        opts.forEach(function (v, i) {
          var l = root.querySelector('[data-option-label="' + i + '"]');
          if (l) l.textContent = v;
        });
        var variant = product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        if (!variant) {
          addBtn.disabled = true;
          addBtn.textContent = theme.strings.unavailable;
          return;
        }
        idInput.value = variant.id;
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
        if (priceEl) priceEl.textContent = formatMoney(variant.price, theme.moneyFormat);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.hidden = false;
            compareEl.textContent = formatMoney(variant.compare_at_price, theme.moneyFormat);
          } else { compareEl.hidden = true; }
        }
        if (variant.featured_media) {
          var t = root.querySelector('[data-thumb][data-media-id="' + variant.featured_media.id + '"]');
          if (t) showMedia(t.dataset.src, variant.featured_media.id);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      radios.forEach(function (r) { r.addEventListener('change', update); });
    });
  });
})();
